import { _baseClient } from '../index';
import { withPagination } from '../pagination';

export const exportTaskTemplateList = (params) => {
  return _baseClient.post('/task-template/export', { body: params }).then((response) => {
    return response;
  });
};
export const exportLikeImportTaskTemplateList = (params) => {
  return _baseClient
    .post('/task-template/export-like-import', { body: params })
    .then((response) => {
      return response;
    });
};
export const taskTemplateChangePriority = (params) => {
  return _baseClient.post('/task-template/change-priority', { body: params });
};

export const taskTemplateRiskRank = (params) => {
  return _baseClient.post('/task-template/change-risk-rank', { body: params });
};

export const taskTemplateSelectList = (pageSize, pageNumber, query = {}) => {
  return withPagination(
    (state) =>
      _baseClient.post('/task-template/select-list', {
        body: {
          pageSize: state.pageSize,
          pageNumber: state.pageNumber,
          ...query,
        },
      }),
    { pageSize, pageNumber },
  );
};
export const taskTemplateList = (pageSize, pageNumber, query = {}) => {
  return withPagination(
    (state) =>
      _baseClient.post('/task-template/list', {
        body: {
          pageSize: state.pageSize,
          pageNumber: state.pageNumber,
          ...query,
        },
      }),
    { pageSize, pageNumber },
  );
};
export const taskTemplateSave = (params) => {
  return _baseClient.post('/task-template/save', { body: params }).then((response) => {
    return response;
  });
};
export const taskTemplateDelete = (params) => {
  return _baseClient.post('/task-template/delete', { body: params });
};

export const taskTemplateGet = (params) => {
  return _baseClient.get('/task-template/get', params);
};
export const taskTemplateClone = (params) => {
  return _baseClient.get('/task-template/clone', params);
};
export const downloadTaskTemplateSampleCsv = (params) => {
  return _baseClient.get('/task-template/download-sample-csv', params);
};
export const downloadTaskTemplateActivityTypeSampleCsv = (params) => {
  return _baseClient
    .get('/task-template/download-activity-type-sample-csv', params)
    .then((response) => {
      return response;
    });
};

export const taskTemplateFilter = (params) => {
  return _baseClient.post('/task-template/filter-data', { body: params });
};

export const taskTemplateReportList = (pageSize, pageNumber, query = {}) => {
  return _baseClient.get('/task-template/get-client-tasks', {
    pageSize: pageSize,
    pageNumber: pageNumber,
    ...query,
  });
};

export const taskTemplateUpdateStatus = (params) => {
  return _baseClient.get('/task-template/update-status', params);
};
export const taskTemplateEmailDelete = (params) => {
  return _baseClient.get('/task-template/delete-email-template', params);
};
